import React from "react";

export const HowFindLinkOnAlbum: React.FC = () => {
  return <div id={"HowFindLinkOnAlbum"}>
    <h2>
      Где найти ссылку на альбом
    </h2>
    <p>
      Перейдите в раздел Альбомы, откройте нужный альбом и нажмите кнопку URL. Ссылка скопировалась в буфер обмена.
    </p>
    <div className={"text-center"}>
      <img className={"max-h-[350px]"} src={"/help/copy-album-url.jpg"} alt={"Добавить новый альбом"} />
    </div>
    <p className={'mt-3'}>
      Единая ссылка поможет пользователям не запутаться и самостоятельно выбрать, на какой платформе они хотят послушать
      ваш релиз. С открывшейся страницы альбома слушатели смогут перейти в веб-версию ВКонтакте или приложение VK
      Музыка.
    </p>
    <p>
      Обратите внимание:
    </p>
    <ul className={"list-disc"}>
      <li>
        Ссылка появится только после того, как альбом будет обработан системой и площадками
      </li>
      <li>
        Ссылка недоступна для всех видеоальбомов
      </li>
      <li>
        Альбом по ссылке будет доступен только после наступления даты релиза всех треков альбома
      </li>
    </ul>
  </div>;
};
